import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const CreateGenericAccountWrapper = styled.div`
  color: ${COLORS.cirrus_black};
  padding: 0px 8px;

  ${responsive.MOBILE`
    padding: 0;
  `}
  .MuiAccordionSummary-root {
    padding: 0px;
    margin: 0px;
    padding-right: 24px;

    ${responsive.MOBILE`
      padding-right: 16px;
    `}
  }

  .separator-space {
    margin: 16px 0px;

    ${responsive.MOBILE`
      margin: 16px 0 0 0;
    `}
  }

  .Mui-expanded {
    .MuiAccordionSummary-root {
      margin: 0px;
      background: ${COLORS.primary_light_blue2};
    }
  }
  .MuiAccordionSummary-root {
    background: ${COLORS.primary_light_blue2};
  }

  .MuiAccordionSummary-content {
    margin: 0px;
  }

  .accordion-expanded {
  }
  .header-collapse {
    padding-right: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    ${responsive.MOBILE`
      padding-right: 0;
    `}
  }
  .form-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    justify-content: space-between;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .form-header-add-contact {
    height: auto;
  }
  .add-contact-icon {
    margin-right: 6px;
  }
  .container-bottom {
    ${responsive.MOBILE`
      padding: 0 8px 16px 8px;
      margin: 16px 0;
    `}
  }
`;
